import React, { useState, useEffect } from 'react';
import { Calendar, Users, BookOpen, Info, ChevronLeft, ChevronRight } from 'lucide-react';

const App = () => {
  const [currentPage, setCurrentPage] = useState('accueil');
  const [selectedFormation, setSelectedFormation] = useState(null);

  const NavLink = ({ page, icon, children }) => (
    <button 
      onClick={() => setCurrentPage(page)}
      className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all duration-300 ${currentPage === page ? 'bg-indigo-600 text-white shadow-lg' : 'text-gray-600 hover:bg-indigo-100'}`}
    >
      {icon}
      <span>{children}</span>
    </button>
  );

  const renderContent = () => {
    switch(currentPage) {
      case 'formations':
        if (selectedFormation) {
          switch (selectedFormation) {
            case 'SST':
              return <FormationSST onBack={() => setSelectedFormation(null)} />;
            case 'CSSCT':
              return <FormationCSSCT onBack={() => setSelectedFormation(null)} />;
            case 'gestesEtPostures':
              return <FormationGestesEtPostures onBack={() => setSelectedFormation(null)} />;
            case 'Hygiene':
              return <FormationHygieneAlimentaire onBack={() => setSelectedFormation(null)} />;
            case 'documentUnique':
              return <FormationdocumentUnique onBack={() => setSelectedFormation(null)} />;
            default:
              return null;
          }
        }
        return (
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-indigo-800">Nos formations</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { key: 'documentUnique', name: 'Formation Accompagnement à la rédaction du document unique', description: 'Cette formation vous permettra d’acquérir une méthodologie d’évaluation des risques et de retranscrire cette évaluation dans un document.' },
              { key: 'SST', name: 'Formation SST', description: 'Apprenez les gestes de premiers secours en milieu professionnel.' },
              { key: 'gestesEtPostures', name: 'Formation Gestes et Postures', description: 'Optimisez vos postures pour réduire les risques physiques.' },
              { key: 'Hygiene', name: 'Formation Hygiène Alimentaire', description: 'Garantissez la qualité et la sécurité des aliments.' },
              { key: 'CSSCT', name: 'Formation CSSCT', description: 'Renforcez vos compétences en sécurité et conditions de travail.' },
            ].map((formation, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <h3 className="text-xl font-semibold text-indigo-800 mb-2">{formation.name}</h3>
                <p className="text-gray-600 mb-4">{formation.description}</p>
                <button
                  className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
                  onClick={() => setSelectedFormation(formation.key)}
                >
                  En savoir plus
                </button>
              </div>
          ))}
            </div>
          </div>
        );
        case 'presentation':
          return (
            <div className="space-y-6 relative">
              <div className="flex justify-between items-start">
                <h2 className="text-3xl font-bold text-indigo-800">
                  Présentation de Valérie GIANGRANDE
                </h2>
                <img
                  src="/dirigeante.jpg"
                  alt="Portrait de Valérie GIANGRANDE"
                  className="w-32 h-32 rounded-full object-cover shadow-lg"
                />
              </div>
              <p className="text-gray-600 leading-relaxed">
                Originaire du Nord de la France et fille de mineur de fond, Valérie GIANGRANDE a toujours été sensibilisée au maintien de la santé des travailleurs. En août 2023, elle a créé sa société « Santé Travail Solutions » avec pour ambition d’accompagner les entreprises dans la gestion de la santé, de la sécurité, et des conditions de travail des salariés.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Avec plus de 20 ans d’expérience en tant que responsable sécurité dans l’industrie alimentaire et au sein d’une collectivité territoriale, et 8 années comme formatrice pour adultes, elle propose des solutions personnalisées pour répondre aux obligations réglementaires des dirigeants d’entreprises, notamment :
                l’évaluation des risques professionnels physiques et mentaux, la rédaction du document unique, la détermination et le suivi du plan d’actions, l’analyse des accidents de travail, et bien plus encore.
              </p>
              <p className="text-gray-600 leading-relaxed">
                En tant qu’IPRP indépendante, elle collabore étroitement avec les dirigeants pour améliorer les conditions de travail, tout en bénéficiant de l’autonomie et de la diversité qu’offre ce métier. Son engagement reflète sa passion pour le bien-être des travailleurs et l’amélioration des performances des entreprises.
              </p>
              <div className="bg-indigo-100 p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-indigo-800 mb-2">Certifications et domaines d'intervention</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-1">
                  <li>Évaluation des risques professionnels et rédaction du document unique</li>
                  <li>Prévention des risques psychosociaux (RPS)</li>
                  <li>Aménagement et accessibilité des ERP</li>
                  <li>Analyse des accidents du travail et maladies professionnelles</li>
                  <li>Sensibilisation et formation en sécurité, hygiène et ergonomie</li>
                </ul>
              </div>
            </div>
          );      
      case 'calendrier':
        return (
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-indigo-800">Calendrier des formations</h2>
            <CalendarComponent />
          </div>
        );
      default:
        return (
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-indigo-800">Bienvenue chez Santé Travail Solutions</h2>
            <div className="text-gray-600 leading-relaxed">

              <p>
                <strong>Santé Travail Solutions</strong>, cabinet conseil dirigé par <strong>Valérie Giangrande</strong> et fondé en juin 2023, propose des prestations de conseil et des formations dans les domaines de la <strong>sécurité au travail</strong> et de l'<strong>hygiène</strong>.
              </p>
              <br/>
              <p>
              <strong>Forte d’une expérience professionnelle de plus de 30 ans</strong>, acquise au sein d’entreprises privées et de collectivités territoriales, je vous accompagne dans les domaines suivants :
              </p>
              <ul className="list-disc ml-6">
                <li>Préservation de la santé et de la sécurité des salariés,</li>
                <li>Amélioration de la qualité de vie au travail (<strong>SQVCT</strong>),</li>
                <li>Sécurité et accessibilité des ERP,</li>
                <li>Hygiène des bâtiments.</li>
              </ul>
              <p>
              <br/>
                <strong>Certifications et enregistrements :</strong>
              </p>
              <ul className="list-disc ml-6">
                <li><strong>IPRP</strong> enregistrée auprès de la <strong>DREETS Bretagne</strong> sous le N° BRET/2023/019,</li>
                <li>Consultante évaluatrice des démarches <strong>QVT</strong> certifiée par <strong>AFNOR</strong> depuis le 9 octobre 2023,</li>
                <li>Référencée sur la plateforme <strong>REFLEX QVT</strong> (<strong>ANACT</strong>).</li>
              </ul>
              <p>
                Passionnée par mon métier, je m’engage à créer un environnement de travail sain, épanouissant et productif pour vos collaborateurs.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  title: 'Expertise',
                  description:
                    'Profitez de notre expertise pointue dans l’analyse et la gestion des risques professionnels, adaptée à votre secteur.',
                },
                {
                  title: 'Formations',
                  description:
                    'Accédez à des formations complètes et pratiques pour développer vos compétences et celles de votre équipe.',
                },
                {
                  title: 'Accompagnement',
                  description:
                    'Bénéficiez d’un accompagnement personnalisé pour élaborer des solutions sur mesure pour vos besoins spécifiques.',
                },
              ].map((feature, index) => (
                <div key={index} className="bg-indigo-100 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-2">{feature.title}</h3>
                  <p className="text-gray-700">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-100 py-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        <header className="mb-10">
          <h1 className="text-4xl font-bold text-indigo-800 mb-6 text-center">Santé Travail Solutions</h1>
          <nav className="flex flex-wrap justify-center gap-4">
            <NavLink page="accueil" icon={<Info size={18} />}>Accueil</NavLink>
            <NavLink page="presentation" icon={<Users size={18} />}>Présentation</NavLink>
            <NavLink page="calendrier" icon={<Calendar size={18} />}>Calendrier</NavLink>
            <NavLink page="formations" icon={<BookOpen size={18} />}>Formations</NavLink>
          </nav>
        </header>
        <main className="bg-white rounded-xl shadow-2xl p-8 mb-10">
          {renderContent()}
        </main>
        <footer className="text-center text-gray-500">
          <p>&copy; 2024 Santé Travail Solutions. Tous droits réservés.</p>
        </footer>
      </div>
    </div>
  );
};

// Composants pour les pages détaillées de chaque formation
const FormationSST = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation SST (Sauveteur Secouriste du Travail)</h2>
    <p className="text-gray-600">La formation initiale de Sauveteur Secouriste du Travail (SST) permet au salarié formé d'intervenir rapidement et efficacement lors d'une situation d'accident du travail dans l'établissement ou dans la profession.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Déroulé de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Situer le cadre juridique de son intervention</li>
      <li>Réaliser une protection adaptée</li>
      <li>Examiner la victime</li>
      <li>Faire alerter ou alerter</li>
      <li>Secourir la victime de manière appropriée</li>
      <li>Situer son rôle de SST dans l'organisation de la prévention de l'entreprise</li>
      <li>Contribuer à la mise en œuvre d'actions de prévention</li>
      <li>Informer les personnes désignées dans le plan d'organisation de la prévention de l'entreprise de la/des situation(s) dangereuse(s) repérée(s)</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 14 heures</p>
      <p className="text-gray-700">Validité : Certificat valable 24 mois</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationCSSCT = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation CSSCT (Comité de Santé, Sécurité et Conditions de Travail)</h2>
    <p className="text-gray-600">La formation CSSCT permet aux membres du CSE de développer leurs aptitudes en matière de santé, de sécurité et de conditions de travail.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Déroulé de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Connaître le cadre juridique et réglementaire en matière de santé et sécurité au travail</li>
      <li>Identifier les enjeux de la prévention des risques professionnels</li>
      <li>Analyser les conditions de travail et identifier les risques</li>
      <li>Participer à l'élaboration de la politique de prévention</li>
      <li>Exercer ses missions au sein du CSE en matière de SSCT</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 5 jours selon la taille de l'entreprise</p>
      <p className="text-gray-700">Public : Membres du CSE</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationGestesEtPostures = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Gestes et Postures</h2>
    <p className="text-gray-600">La formation en gestes et postures est conçue pour réduire les risques d'accidents et maladies professionnels liés à l'activité physique au travail.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Contenu de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Apprendre les techniques de soulèvement correctes</li>
      <li>Comprendre l'importance de l'ergonomie au travail</li>
      <li>Pratiquer des exercices de prévention des blessures</li>
      <li>Identifier et corriger les postures nuisibles</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 12 heures réparties sur deux jours</p>
      <p className="text-gray-700">Public : Tous les employés exposés à des risques ergonomiques</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationHygieneAlimentaire = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Hygiène Alimentaire</h2>
    <p className="text-gray-600">Essentielle pour les professionnels de la restauration, cette formation garantit la sécurité et la qualité alimentaires conformément aux normes en vigueur.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Comprendre les fondamentaux de l'hygiène alimentaire</li>
      <li>Appliquer les principes de la méthode HACCP</li>
      <li>Prévenir les contaminations et les intoxications alimentaires</li>
      <li>Maintenir un environnement de travail propre et sûr</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 14 heures</p>
      <p className="text-gray-700">Public : Professionnels de la restauration</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationdocumentUnique = ({ onBack }) => (
   <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Accompagnement à la rédaction du document unique</h2>
    <p className="text-gray-600">Le document unique est un document obligatoire issu de l’évaluation des risques professionnels de votre entreprise. Cette formation vous permettra d’acquérir une méthodologie d’évaluation des risques et de retranscrire cette évaluation dans un document. </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
     <li>Connaitre la réglementation applicable et les enjeux</li>
     <li>Connaitre les différents types de risques selon l’INRS </li>
     <li>Evaluer les risques au sein de vos unités de travail</li>
     <li>Hiérarchiser les risques pour construire son plan d’actions (ou PAPRIPACT)</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
     <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
     <p className="text-gray-700">Durée : 14 heures</p>
     <p className="text-gray-700">Public : Responsable RH, secrétaire de direction, Salarié désigné compétent, assistant de prévention…</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
     Retour
      </button>
     </div>
);

const CalendarComponent = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calendar, setCalendar] = useState([]);

  const formations = [
    { date: new Date(2024, 6, 15), name: 'Formation SST' },
    { date: new Date(2024, 6, 22), name: 'Formation CSSCT' },
    { date: new Date(2024, 7, 5), name: 'Formation Gestes et Postures' },
    { date: new Date(2024, 7, 19), name: 'Formation SST' },
  ];

  useEffect(() => {
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    
    const calendarDays = [];
    const startDate = new Date(firstDayOfMonth);
    startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
    
    while (startDate <= lastDayOfMonth || calendarDays.length < 6) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        week.push(new Date(startDate));
        startDate.setDate(startDate.getDate() + 1);
      }
      calendarDays.push(week);
    }
    
    setCalendar(calendarDays);
  }, [currentDate]);

  const getWeekNumber = (date) => {
    const d = new Date(Date.UTC(date.getFullYear, date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1)/7);
  };

  const getFormationForDate = (date) => {
    return formations.find(f => f.date.toDateString() === date.toDateString());
  };

  const changeMonth = (increment) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + increment);
    setCurrentDate(newDate);
  };

  const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  };

  return (
    <div className="mt-8 bg-white rounded-lg shadow-xl p-6">
      <div className="flex justify-between items-center mb-6">
        <button onClick={() => changeMonth(-1)} className="p-2 bg-indigo-100 rounded-full text-indigo-600 hover:bg-indigo-200 transition-all duration-300">
          <ChevronLeft size={24} />
        </button>
        <h2 className="text-3xl font-bold text-indigo-800">
          {currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
        </h2>
        <button onClick={() => changeMonth(1)} className="p-2 bg-indigo-100 rounded-full text-indigo-600 hover:bg-indigo-200 transition-all duration-300">
          <ChevronRight size={24} />
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="p-2 border-b-2 border-indigo-200 bg-indigo-50 text-indigo-800">Sem.</th>
              {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map(day => (
                <th key={day} className="p-2 border-b-2 border-indigo-200 bg-indigo-50 text-indigo-800">{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {calendar.map((week, i) => (
              <tr key={i}>
                <td className="border p-2 text-center font-semibold text-indigo-600 bg-indigo-50">{getWeekNumber(week[0])}</td>
                {week.map((day, j) => {
                  const formation = getFormationForDate(day);
                  return (
                    <td key={j} className={`border p-1 h-24 transition-all duration-300 ${
                      isToday(day) ? 'bg-yellow-100 shadow-inner' :
                      day.getMonth() !== currentDate.getMonth() ? 'bg-gray-100 text-gray-400' :
                      j === 5 || j === 6 ? 'bg-indigo-50' : 'hover:bg-indigo-50'
                    }`}>
                      <div className={`text-center ${isToday(day) ? 'font-bold text-indigo-800' : ''}`}>{day.getDate()}</div>
                      {formation && (
                        <div className="mt-1 p-1 bg-indigo-200 text-indigo-800 text-xs rounded-full truncate shadow-sm">{formation.name}</div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default App;
